export default "__VITE_ASSET__BuGz2$ZC__"